export const tableClass = 'Select_DropDown'
